import { Link } from "react-router-dom";
import Header from "./Header/Header";
import icon07_1 from "../../screenassets/images/img/07_1.png";
import icon08_1 from "../../screenassets/images/img/08_1.png";
import icon09_1 from "../../screenassets/images/img/09_1.png";
import icon03_2 from "../../screenassets/images/img/03_2.png";
import icon02_2 from "../../screenassets/images/img/02_2.png";
import { MdCheck } from "react-icons/md";
import Footer from "./Footer/Footer";
import Banner from "./Header/Banner";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from "react-redux";
import Icons from "./Pages/Icons";


export default function Home() {

  const [packages, stePackages] = useState([]);
  const [grade, setGrade] = useState("6-8");
  const [swip, setSwip] = useState("1");
  const userSubscription = useSelector((state) => state?.userSlice?.userSubscription)
  const userDetails = useSelector((state) => state?.userSlice?.value)
  // Show All Package Section
  const fetchAllPackage = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getAllPackage`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.json();
  };

  useEffect(() => {
    fetchAllPackage().then((res) => {
      if (res.status) {
        stePackages(res.packages);
      } else {
        toast.error("Failed to load package. Please try again.");
      }
    }).catch((error) => {
      toast.error("Unable to fetch package at the moment.");
    });
  }, []);

  function handleSwip(val) {
    setSwip(val);
  }
  function handleGrade(val) {
    setGrade(val);
  }

  return (
    <>
      {/* Toast container */}
      < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

      {/* Header Section */}
      <Header />

      {/* banner area start */}
      <Banner />

      {/* feature area start */}
      <div className="rts-feature-area rts-section-gapBottom mt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-conter-area">
                <h2 className="title">
                  How It Works<br />
                  (3-Step Process)
                </h2>
                <p className="disc">
                  Get Homework Help in 3 Simple Steps.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt--50">
            <div className="col-lg-12">

              <div className="single-feature-area-start index-feature">
                <div className="image-area">
                  <img src={icon07_1} alt="feature_image" loading="lazy" />
                </div>
                <div className="featue-content-area">
                  <span className="pre">01</span>
                  <h2 className="title">
                    Write or Upload Your <br />
                    Question
                  </h2>
                  <p className="disc">
                    Write or upload your question and then select medium and subject. Our system detect your board and generate solution step by step.
                  </p>
                  <Link href="/signin" className="rts-btn btn-primary"
                  >Get Started Free</Link>
                </div>
              </div>

              <div className="single-feature-area-start index-feature bg-red-l">
                <div className="featue-content-area">
                  <span className="pre">02</span>
                  <h2 className="title">
                    Verified Step-by-Step <br />
                    Solutions
                  </h2>
                  <p className="disc">
                    Our system generate 100% verified answers, written in your preferred language step by step.
                  </p>
                  <Link to="/signin" className="rts-btn btn-primary">Get Started Free</Link>
                </div>
                <div className="image-area">
                  <img src={icon08_1} alt="feature_image" loading="lazy" />
                </div>
              </div>

              <div className="single-feature-area-start index-feature bg-blue-l">
                <div className="image-area">
                  <img src={icon09_1} alt="feature_image" loading="lazy" />
                </div>
                <div className="featue-content-area">
                  <span className="pre">03</span>
                  <h2 className="title">
                    Learn. Revise. <br />
                    Master.
                  </h2>
                  <p className="disc">
                    Download detailed PDF solutions, revise formulas, and practice board-style questions anytime.
                    Perfect for last-minute exam prep or daily homework help.
                  </p>
                  <Link to="/signin" className="rts-btn btn-primary">Get Started Free</Link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* tools area start */}
      <div className="rts-tools-area rts-section-gap bg-tools">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-conter-area">
                <h2 className="title">
                  Subjects We Cover <br />
                  for you
                </h2>
                <p className="disc">
                  Everything You Need — From Homework to Board Preparation
                  Learn smarter with verified, step-by-step answers across every subject and stream.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt--25 g-5">
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">

              <div className="single-tools-feature">
                <div className="">
                  <Icons image={require("../../screenassets/images/img/calculating.png")} />
                </div>
                <h5 className="title">Maths Mastery</h5>
                <p className="disc">
                  Get clear, step-by-step explanations for every math problem — from basic arithmetic to board-level geometry, algebra, and trigonometry.
                </p>
              </div>

            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="single-tools-feature">
                <div className="">
                  <Icons image={require("../../screenassets/images/img/chemistry.png")} />
                </div>
                <h5 className="title">Science Simplified</h5>
                <p className="disc">
                  Understand concepts, experiments, and numericals across Physics, Chemistry & Biology — all in your preferred language.
                  Designed for easy learning and quick revision before exams.
                </p>
              </div>

            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">

              <div className="single-tools-feature">
                <div className="">
                  <Icons image={require("../../screenassets/images/img/science.png")} />
                </div>
                <h5 className="title">Physics, Chemistry & Biology</h5>
                <p className="disc">
                  From CHSE Physics numericals to WBCHSE Biology long answers, find verified, board-specific solutions with formulas and reasoning.
                  Ideal for students preparing for boards or entrance exams.
                </p>
              </div>

            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">

              <div className="single-tools-feature">
                <div className="">
                  <Icons image={require("../../screenassets/images/img/business-and-finance.png")} />
                </div>
                <h5 className="title">Commerce Concepts</h5>
                <p className="disc">
                  Step-by-step clarity in Accountancy, Business Studies, Economics, and Statistics.
                  Each chapter is explained with formulas, workings, and real-world examples.
                </p>
              </div>

            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">

              <div className="single-tools-feature">
                <div className="">
                  <Icons image={require("../../screenassets/images/img/social-studies.png")} />
                </div>
                <h5 className="title">Social Studies & Humanities</h5>
                <p className="disc">
                  Deepen your understanding of History, Geography, Political Science, Civics, Sociology, and Psychology.
                  Crisp, exam-ready notes with pointwise explanations in your own medium.
                </p>
              </div>

            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">

              <div className="single-tools-feature">
                <div className="">
                  <Icons image={require("../../screenassets/images/img/languages.png")} />
                </div>
                <h5 className="title">Language Learning</h5>
                <p className="disc">
                  Master English grammar, comprehension, essays, and letter writing, plus Hindi & regional language papers.
                  Get examples aligned with board-style marking and previous-year trends.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* pricing area start */}
      <div className="rts-pricing-area rts-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-conter-area">
                <h2 className="title">
                  Try For Free, No Credit <br />
                  Card Required
                </h2>
              </div>
            </div>
          </div>



          <ul className="nav mt--20 nav-tabs pricing-button-one" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true" onClick={() => { handleGrade("6-8") }}>
                6-8
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false" onClick={() => { handleGrade("9-10") }}>
                9-10
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false" onClick={() => { handleGrade("11-12") }}>
                11-12
              </button>
            </li>

          </ul>


          <ul className="nav mt--20 nav-tabs pricing-button-one" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true" onClick={() => { handleSwip("1") }}>
                Monthly
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false" onClick={() => { handleSwip("2") }}>
                Yearly
              </button>
            </li>
            <li className="right-image-inner">
              <img src={icon03_2} alt="cta-wrapper" loading="lazy" />
            </li>
          </ul>

          <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab" >
              <div className="row g-5 mt--20">

                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">

                  <div className="pricing-style-one">
                    <div className="head">
                      <span className="top">Free</span>
                      <div className="date-use">
                        <h4 className="title">Free</h4>
                        <span>/month</span>
                      </div>
                    </div>
                    <div className="body">
                      {!userSubscription ? <div className="rts-btn btn-border-p notable">Start Free Trial</div> : <Link to="#" className="rts-btn btn-border-p selected">Selected</Link>}
                      <div className="chek-area">

                        <div className="single-check">
                          <MdCheck className="me-2" />
                          <p className="mb-0">3 Request</p>
                        </div>

                        <div className="single-check">
                          <MdCheck className="me-2" />
                          <p className="mb-0">All types of grade</p>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>

                {packages.map((pack, indx) => {
                  // const levelName = JSON.parse(pack.grade);
                  const description = JSON.parse(pack.description);

                  return pack.grade == grade && pack.type == swip ? <div key={indx} className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="pricing-style-one">
                      <div className="head">
                        <span className="top">{pack.name}</span>
                        <div className="date-use">
                          <h4 className="title">&#8377;{pack.amount}</h4>
                          <span>/{pack.type === 2 ? "Yearly" : "Monthly"}</span>
                        </div>
                      </div>
                      <div className="body">
                        {userSubscription && (userSubscription?.package_id < pack.id) ? <Link className="rts-btn btn-border-p notable" >Upgrade</Link> : userSubscription && (userSubscription?.package_id == pack.id) ? <Link className="rts-btn btn-border-p selected" >Selected</Link> : <Link to={userDetails ? '/user/packagehistory' : '/'} className="rts-btn btn-border-p" >Upgrade</Link>}

                        {/* <div className="d-flex flex-wrap align-items-center mt-6" style={{ paddingLeft: "1.4em" }}> {pack.total_request} <h6 className="m-0 me-2 ms-2"> Total Request</h6></div> */}

                        <div className="chek-area">
                          {description.map((desc, id) => {
                            return <div key={id} className="single-check">
                              <MdCheck className="me-2" />
                              <p className="mb-0">{desc}</p>
                            </div>
                          })}
                        </div>

                      </div>
                    </div>

                  </div>
                    :
                    null

                })}


              </div>
            </div>


          </div>

        </div>
      </div>

      {/* faq area start */}
      <div className="rts-faq-area rts-section-gap bg_faq">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-conter-area">
                <h2 className="title">
                  Questions About Our Study Platform? <br />
                  We Have the Answers!
                </h2>
                <p className="disc">
                  We’ve got quick answers to help you get started.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt--60">
            <div className="col-lg-12">
              <div className="accordion-area-one">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        How do I upload a question?
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        Simply take a photo or type it. Our AI instantly reads and solves it step-by-step.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Which boards do you support?
                      </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        Every board all over the India. You can select board which are given in dropdown section or you can add your custom board by selecting custom board option while signup or edit profile section.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Are the answers verified?
                      </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        Yes, every solution is reviewed by subject experts to ensure accuracy.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        Is it available in my language?
                      </button>
                    </h2>
                    <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        Absolutely! You can choose more over 20 languages and you can add your custom language also in your edit profile section.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                        Can I download the solutions as a PDF?
                      </button>
                    </h2>
                    <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        Yes! you can download step-by-step verified solutions as PDFs for offline study — perfect for last-minute board exam revision or sharing with friends.
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* cta area start */}
      <div className="rts-cta-area rts-section-gapBottom bg_faq">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="cta-main-wrapper bg_image">
                <div className="left">
                  <h3 className="title">
                    Get Trusted Board Exam Solutions — <br />
                    Anytime, Anywhere
                  </h3>
                  <Link href="/signin" className="rts-btn btn-primary">Upload a Question Now</Link>
                </div>
                <div className="right">
                  <img src={icon02_2} alt="cta-area" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <Footer />

    </>
  )
}
